import { RiskCategoryType, RiskCategoryTypeLegacy } from './PeriodType';

export enum PayoutType {
  OneOff = 'EENMALIG',
  Monthly = 'MAANDELIJKS'
}

export enum SustainableRiskCategory {
  Rent = 'Rente'
}

export const RiskCategories = {
  DEFAULT: [
    RiskCategoryType.nhg,
    RiskCategoryType.smallerThanOrEqualTo65Percent,
    RiskCategoryType.smallerThanOrEqualTo85Percent,
    RiskCategoryType.smallerThanOrEqualTo90Percent,
    RiskCategoryType.largerThan90Percent
  ],
  overwaarde: [PayoutType.OneOff, PayoutType.Monthly],
  duurzaam: [SustainableRiskCategory.Rent],
  startzeker: [RiskCategoryType.nhg]
};

export const RiskCategoriesLegacy = {
  DEFAULT: [RiskCategoryType.nhg, RiskCategoryType.smallerThanOrEqualTo65Percent, RiskCategoryType.smallerThanOrEqualTo85Percent, RiskCategoryTypeLegacy.largerThan85Percent],
  overwaarde: [...RiskCategories.overwaarde],
  duurzaam: [...RiskCategories.duurzaam],
  startzeker: [...RiskCategories.startzeker]
};
